(ns frontend.view.task.email.events
  (:require
   [clojure.set :as set]
   [clojure.string :as string]
   [common.email :as cemail]
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.actions.entity :as entity-actions]
   [frontend.actions.task :as task-actions]
   [frontend.logging :as logging]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.delete-confirmation.view :as delete-confirmation-modal]
   [frontend.view.modals.notification.view :as notification-modal]
   [frontend.view.task.email.db :as db]
   [potpuri.core :as potpuri :refer [fn-> fn->> index-by]]
   [reagent.core :as r]
   [reagent.ratom :as ratom]
   [frontend.view.modals.account-select.view :as account-select]
   [frontend.view.error-utils :as error-utils]))

(def test-data
  {"testing"           {:db/id             "testing"
                        :common/tenant     (:db/id @session/tenant)
                        :entity/type       :entity.type/task
                        :task/type         :task.type/email
                        :task/relates      #{"test-email-id" #_17592186302084}
                        :task/assignee     17592186274802
                        :common/created-on 1596451527966
                        :common/updated-on 1596451527966
                        :common/created-by 17592186274802
                        :task/created      1596451527965
                        :common/updated-by 17592186274802
                        :task/assigner     17592186274802}
   #_17592186302084
   "test-email-id"
   {:db/id              "test-email-id"
    #_17592186302084
    :email/from         "timo Pirinen <timo@zapflow.com>"
    :common/tenant      (:db/id @session/tenant)
    :common/attachments #{"test-attachment-1" "test-attachment-2"}
    #_#{17592186302085 17592186302086}
    :common/created-on  1596451527962
    :common/updated-on  1596451527962
    :common/created-by  17592186274802
    :common/updated-by  17592186274802
    :email/date         "Wed, 22 Mar 2017 16:23:26 +0200"
    :entity/type        :entity.type/email
    :email/subject
    "This is subject withalongwordtocasdfoijsdoijsdfoisfdjofsijosfaijodasijfdaaaaaaaaaaaaaaaaaaaaaaaaaa // Dealname"
    :email/bucket       "mail.zapflow.com"
    :email/to
    "bill.gates@microsoft.com, \"Jane Doe\" <jane@example.com>, \"Mary Doe\" <mary@example.com>, \"Richard Doe\" <richard@example.com>, andrew@zapflow.com, longemaillonglongasdasdasdasdasdasdasdasdasdasdasd@fsdfdsfsdfsdfdsfsdfsdfdsfsdfasdfasdfasd.com, admin@asd.dfg"
    :email/body
    "With attachment\n\n2nd line\n\n3rd line\n\nyet another long line here with multiple lines of text yet another long line here with multiple lines of text yet another long line here with multiple lines of text yet another long line here with multiple lines of text yet another long line here with multiple lines of text yet another long line here longwordloooooooooooooooooooooooooooooooooooooooooooooooontoseeiflayoutbreaks with multiple lines of text yet another long line here with multiple lines of text yet another long line here with multiple lines of text yet another long line here with multiple lines of text yet another long line here with multiple lines of text yet another long line here with multiple lines of text \r\n"}
   ;;17592186302085 {:db/id 17592186302085
   "test-attachment-1" {:db/id "test-attachment-1"
                        :common/tenant (:db/id @session/tenant)
                        :attachment/created 1596451527962
                        :entity/type :entity.type/attachment
                        :attachment/content-length 4107
                        :attachment/filename "small-example-pdf-file.pdf"
                        :attachment/content-type "application/pdf"}
   ;;17592186302086 {:db/id 17592186302086
   "test-attachment-2"
   {:db/id "test-attachment-2"
    :common/tenant (:db/id @session/tenant)
    :attachment/created 1596451527962
    :entity/type :entity.type/attachment
    :attachment/content-length 4107
    :attachment/filename
    "aanother-example-pdf-withlongnamenamenameamadsfasdfkljasdfjasldfkjasdlfkjasdlfkjasd.pdf"
    :attachment/content-type "application/pdf"}
  })

(def test-ids
  (-> test-data
      keys
      set))

(defn test-id?
  [entity-id]
  (contains? test-ids entity-id))

;;test code - left for reference:
#_(defn get-entity
    [entity-id]
    (if (test-id? entity-id)
      (get test-data entity-id)
      (get @session/entities entity-id)))

(defn get-entity
  [entity-id]
  (get @session/entities entity-id))

(defn hide-linkable!
  [entity]
  (swap! db/state update :hidden (fnil conj #{}) (:db/id entity)))

(defn unhide-linkable!
  [entity]
  (swap! db/state update :hidden (fnil disj #{}) (:db/id entity)))

(defn emails-from-string
  [email-string]
  (let [email-addresses (re-seq cemail/email-pattern (string/lower-case (str email-string)))]
    email-addresses))

(defn ignore-email?
  [email]
  (cemail/valid-contact-email? email))

;;TODO should we also try to parse first and last names to help creation?
;;     (to-field might contain e.g. "\"Jane Doe\" <jane@example.org>")
(defn email-addresses
  [email]
  (let [{:keys [email/to email/from email/cc]} email
        ;;remove account-emails?
        addresses (->> [to from cc]
                       (mapcat emails-from-string)
                       (map cu/str-trim-lcase)
                       (remove string/blank?)
                       (remove ignore-email?)
                       distinct)]
    addresses))

;;reactions (or cursors when applicable)
;; when using @(re-frame/subscribe [:email-task-resolution/task-id])
;;  it's clear that it's a database subscription
;;  => naming convention (or a layer of indirection) might be useful here
(def task-id (r/cursor db/state [:task-id]))

(def prevent-delete (r/cursor db/state [:prevent-delete]))

(def hidden (r/cursor db/state [:hidden]))

(def task
  (ratom/reaction
   (get-entity @task-id)))

(def no-task?
  (ratom/reaction
   (let [task @task]
     (or (nil? task)
         (:common/disabled? task)))))

(def completed?
  (ratom/reaction
   (:task/completed? @task)))

(def email
  (ratom/reaction
   (->> @task
        :task/relates
        (keep get-entity)
        (cu/only-entity :entity.type/email)
        (remove :common/disabled?)
        first)))

(def no-email?
  (ratom/reaction
   (nil? @email)))

(def attachments
  (ratom/reaction
   (->> @email
        :common/attachments
        (map get-entity)
        (remove :common/disabled?)
        (sort-by :common/created-on)
        doall)))

(def related-entities-set
  (ratom/reaction
   (or (some->> (get-in @db/temp-state [:email :common/related-entities])
                set)
       (->> @email
            :common/related-entities
            set))))

(def contact-email-lookup
  (ratom/reaction
   (->> @session/all-persons
        (remove (fn-> :person/universal-email-address string/blank?))
        (index-by (fn-> :person/universal-email-address string/trim string/lower-case)))))

;;potential way of testing:
#_(with-redefs [contacts-cursor (atom [{:person/universal-email-address "a@a.a" :db/id 123}
                                       {:person/universal-email-address "b@b.b" :db/id 223}
                                       {:note :no-email :db/id 999}
                                       {:person/universal-email-address "c@c.c" :db/id 323}])]
    (prn "with-redefs>>c-e-l" @contact-email-lookup))

(def account-emails
  (ratom/reaction
   (->> (session/active-accounts nil)
        (map :account/email)
        (map cu/str-trim-lcase)
        (remove string/blank?)
        doall)))

(def resolved-data
  (ratom/reaction
   (or (get-in @db/temp-state [:task :task/resolved-data])
       (->> @task
            :task/resolved-data))))

(def found-from-search
  (ratom/reaction
   (->> @resolved-data
        :found-from-search
        (keep get-entity)
        (remove :common/disabled?)
        distinct
        doall)))

(def previously-linked
  (ratom/reaction
   (->> @resolved-data
        :previously-linked
        (keep get-entity)
        (remove :common/disabled?)
        distinct
        doall)))

#_(def created-ids
    (ratom/reaction
     (->> @resolved-data
          :created-ids
          (keep get-entity)
          (remove :common/disabled?))))
(def created-ids-set
  (ratom/reaction
   (->> @resolved-data
        :created-ids
        set)))

;; re-frame approach: using reactions etc
;; -instead of params, using existing reactions / ratoms / cursors (i.e. signals)
;;  -instead of state, using @created-ids-set (that wraps task-resolved-data and temp-state) etc
;;  -instead of task param, using @task (see definition above)
(def resolve-contacts
  (ratom/reaction
   (let [;;note: we could remove parameters and read those directly from state from reactions above
         task @task
         email @email
         ;;      ^ naming should probably indicate this is a helper (data subscription?) that returns data from database:
         ;;task        @(re-frame/subscribe [:email-resolution/task])
         ;;email        @(re-frame/subscribe [:email-resolution/email])

         inbox-email @session/inbound-email-address

         account-emails @account-emails
         ignored-emails (set (concat account-emails
                                     inbox-email))
         addresses-from-email (->> (email-addresses email)
                                   (remove ignored-emails))
         email-lookup (->> @contact-email-lookup)
         ;;contacts in our database:
         existing (->> addresses-from-email
                       (keep (fn [email]
                               (get email-lookup email))))

         created-from-task @created-ids-set

         existing-contacts (->> existing
                                (remove (fn [contact]
                                          (some #{(:db/id contact)} created-from-task))))
         ;;contacts created from this task's resolution flow:
         created (->> created-from-task
                      (keep (fn [id]
                              (get @session/entities id)))
                      (cu/only-entity :entity.type/person))
         found (->> addresses-from-email
                    (remove (fn [email]
                              (contains? email-lookup email))))]
     [existing-contacts created found])))

(def linkable-contacts
  (ratom/reaction
   (let [[existing created _] @resolve-contacts
         hidden (set @hidden)
         contacts (->> (concat existing created)
                       (remove (fn [{:keys [db/id]}]
                                 (contains? hidden id)))
                       doall)]
     contacts)))

(defn disable-contact!
  [state person]
  (let [on-error! (fn [err]
                    ;;prevent showing delete-icon (local-state suffices here)
                    (swap! state update :prevent-delete (fnil conj #{}) (:db/id person))
                    ;;show notification-modal
                    (modals/open-modal!
                     notification-modal/modal-key
                     {:body-text      (loc/tr :contact-cannot-be-deleted
                                          [(entity/display-string person)])
                      :title          (loc/tr :attention)
                      :ok-button-text (loc/tr :ok)}))
        ;;"%s contact cannot be deleted due to some restriction in the system"
        delete! (fn []
                  (entity-actions/*->disable-raw!
                   {:entity-id (:db/id person)
                    :prevent-if-associations? true}
                   (fn [])
                   on-error!))]
    (modals/open-modal!
     delete-confirmation-modal/modal-key
     {:body       (loc/tr :delete-contact [(entity/display-string person)])
      :on-delete! (fn [_]
                    (delete!))})))

(defn all-entity-types
  []
  (concat (when (session/dealflow?)
            [:entity.type/oppo])
          [:entity.type/company
           :entity.type/person]
          (when (session/fundraising?)
            [:entity.type/fundraising-opportunity])
          (when (session/has-investors-access?)
            [:entity.type/investor])
          (when (session/has-feature-access? :feature/asset-types-real-estate)
            [:entity.type/real-estate])
          (when (session/has-feature-access? :feature/asset-types-fof)
            [:entity.type/fof-asset])
          (when (session/has-feature-access? :feature/asset-types-other)
            [:entity.type/other-asset])
          (when (session/has-funds-access?)
            [:entity.type/fund])
          (when (session/portfolio?)
            [:entity.type/holding])
          (when (session/fundraising?)
            [:entity.type/fund-commitment])
          (when (session/sales-pipelines?)
            [:entity.type/sales-opportunity
             :entity.type/sale-agreement])
          (when (session/exit-process-management?)
            [:entity.type/exit-opportunity])
          (when (session/kyc?)
            [:entity.type/kyc-profile])))

(def selected-entity-type
  (ratom/reaction
   (-> @db/state
       :selected-entity-type
       (or :all))))

(def link-attachments?
  (ratom/reaction
   (-> @db/state
       :link-attachments?
       (or :no))))

(def entity-types
  (ratom/reaction
   (let [selected-entity-type @selected-entity-type]
     (cond (= selected-entity-type :all)
           (all-entity-types)
           (nil? selected-entity-type)
           (all-entity-types)
           :else
           [selected-entity-type]))))

(defn select-entity-type!
  [state entity-type]
  (if (nil? entity-type)
    (swap! state dissoc :selected-entity-type)
    (swap! state assoc :selected-entity-type entity-type)))

(defn change-link-attachments
  [value]
  (if (= :yes value)
    (swap! db/state assoc :link-attachments? :yes)
    (swap! db/state dissoc :link-attachments?)))

(defn association-target
  [entity association]
  (let [entity-id (:db/id entity)
        target-id (:entity-association/target-entity association)
        source-id (:entity-association/source-entity association)
        target-id (if (= target-id entity-id)
                    source-id
                    target-id)
        target-entity (get-entity target-id)]
    target-entity))

;;TODO might be useful in frontend.utils
(defn entity-associations
  [entity]
  (let [entity-id (:db/id entity)]
    (->> entity
         :common/related-entities
         (map get-entity)
         (cu/only-entity :entity.type/entity-association)
         (remove :common/disabled?)
         (filter (fn [a]
                   (or (= (:entity-association/target-entity a) entity-id)
                       (= (:entity-association/source-entity a) entity-id))))
         (remove (fn [association]
                   (let [target (association-target entity association)]
                     (or (nil? target)
                         (:common/disabled? target))))))))

;;needs to list:
;; 1) entities found / created via search
;; 2) contacts found / created in previous step
;; 3) associated entities of those contacts
;; 4) currently linked entities that are none the above (email's :common/related-entities)
;; 5) previously linked entities that are none of the above
;;    (i.e. number 4 entities that were toggled as not linked)
(def linkable-entities
  (ratom/reaction
   (let [[existing created _] @resolve-contacts
         contacts (concat existing created)
         ;; ^ contacts from previous step are listed above the search

         already-listed-set (->> contacts
                                 (map :db/id)
                                 set)
         update-already-listed (fn [current-set entities]
                                 (->> entities
                                      (map :db/id)
                                      set
                                      (set/union current-set)))
         listed? (fn [already-listed-set {:keys [db/id]}]
                   (contains? already-listed-set id))
         found-from-search (->> @found-from-search
                                (remove (partial listed? already-listed-set)))

         already-listed-set (update-already-listed already-listed-set found-from-search)

         associated-entities (->> contacts
                                  (map (juxt identity entity-associations))
                                  (mapcat (fn [[entity associations]]
                                            (->> associations
                                                 (map (partial association-target entity)))))
                                  (remove :common/disabled?)
                                  (remove (partial listed? already-listed-set))
                                  distinct)
         already-listed-set (update-already-listed already-listed-set associated-entities)

         previously-linked (->> @previously-linked
                                (remove (partial listed? already-listed-set)))
         already-listed-set (update-already-listed already-listed-set previously-linked)
         current-related (->> @email
                              :common/related-entities
                              (map get-entity)
                              (remove (partial listed? already-listed-set))
                              distinct)
         already-listed-set (update-already-listed already-listed-set current-related)
         others (->> (concat associated-entities)
                     (concat previously-linked)
                     (concat current-related)
                     (distinct)
                     (sort-by :common/created-on))

         hidden (set @hidden)
         linkable-entities (->> (concat found-from-search others)
                                distinct
                                (remove (fn [{:keys [db/id]}]
                                          (contains? hidden id))))
         entity-types (set (all-entity-types))]
     (->> linkable-entities
          (filter (fn [{:keys [entity/type]}]
                    (contains? entity-types type)))
          doall))))

;;note: this whole pattern might be worth abstracting out
;; notes:
;; -reading the value :common/related-entities should read it from temp-state
;;  (see (def related-entities-set ...))
;; -path should match when reading & associng/dissocing
;;  -probably should be indexed by entity-id (instead of :email below)
;; -currently caller is responsible for checking if the value has changed
;;  -would it make more sense here? (see '(when-not (= new-related current-related) ...)')
(defn save-related-entities!
  [email new-value]
  (let [;;save value into temp-state (used by reaction 'related-entities-set')
        before-save! (fn []
                       (swap! db/temp-state assoc-in
                         [:email :common/related-entities]
                         new-value))
        ;;clearing temp-state:
        on-timeout! (fn []
                      (swap! db/temp-state update :email dissoc :common/related-entities))
        save-fn! (fn [{:keys [on-success!]}]
                   (entity-actions/*->field-update!
                    (:db/id email)
                    :common/related-entities
                    new-value
                    on-success!
                    (fn [err]
                      (logging/error "Failed to update related-entities" err)
                      ;;empty temp state:
                      (on-timeout!))))]
    (fu/temp-timeout
     {:timeout-state db/timeout-state
      :timeout-path  [:related-entities-timeout]
      :before-save!  before-save!
      :on-timeout!   on-timeout!
      :save-fn!      save-fn!
      :delay         500})))

(defn save-resolved-data!
  [task new-value]
  (let [;;save value into temp-state
        before-save! (fn []
                       (swap! db/temp-state assoc-in
                         [:task :task/resolved-data]
                         new-value))
        ;;clearing temp-state:
        on-timeout! (fn []
                      (swap! db/temp-state update :task dissoc :task/resolved-data))
        save-fn! (fn [{:keys [on-success!]}]
                   (entity-actions/*->field-update!
                    (:db/id task)
                    :task/resolved-data
                    new-value
                    on-success!
                    (fn [err]
                      (logging/error "Failed to update related-entities" err)
                      ;;empty temp state:
                      (on-timeout!))))]
    (fu/temp-timeout
     {:timeout-state db/timeout-state
      :timeout-path  [:resolved-data-timeout]
      :before-save!  before-save!
      :on-timeout!   on-timeout!
      :save-fn!      save-fn!
      :delay         500})))

(defn toggle-related!
  [entity new-value add-to-previously-linked? link-attachments?]
  (let [email @email
        email-id (:db/id email)
        task @task
        task-id (:db/id task)
        email-atom (r/cursor session/entities [email-id])
        task-atom (r/cursor session/entities [task-id])
        entity-id (:db/id entity)
        current-related @related-entities-set
        resolved-data @resolved-data
        toggled? (contains? current-related entity-id)
        new-related (cond (= (boolean toggled?) (boolean new-value))
                          current-related
                          new-value
                          ((fnil conj #{}) current-related entity-id)
                          :else
                          ((fnil disj #{}) current-related entity-id))
        new-resolved-data (if add-to-previously-linked?
                            (update resolved-data :previously-linked (fnil conj #{}) entity-id)
                            resolved-data)]
    (when-not (= new-resolved-data resolved-data)
      (save-resolved-data! task new-resolved-data))

    (when (= :yes link-attachments?)
      (entity-actions/*->field-update! entity-id
                                       :common/attachments
                                       (set/union (set (:common/attachments entity))
                                                  (->> @attachments
                                                       (map :db/id)
                                                       (set)))
                                       identity
                                       (fn [err]
                                         (logging/unimplemented "Failed to link attachments : " err))))

    (when-not (= new-related current-related)
      (save-related-entities! email new-related))))

;;needs to be saved in task/resolved-data so it's visible in linkable-entities list
(defn add-linkable-entity!
  [entity-id]
  (let [task @task
        resolved-data @resolved-data
        current-found-from-search (:found-from-search resolved-data)
        add? (->> current-found-from-search
                  (filter (fn [id]
                            (= id entity-id)))
                  empty?)
        new-resolved-data (if add?
                            (update resolved-data
                                    :found-from-search
                                    (fnil conj '())
                                    entity-id)
                            resolved-data)
        link-attachments? @link-attachments?]
    (when (not= resolved-data new-resolved-data)
      (save-resolved-data! task new-resolved-data))
    (unhide-linkable! {:db/id entity-id})
    (toggle-related! {:db/id entity-id} true false link-attachments?)))

(defn save-created-id!
  [new-id]
  (let [task @task
        resolved-data @resolved-data
        current-created (:created-ids resolved-data)
        new-resolved-data (update resolved-data
                                  :created-ids
                                  (fnil conj #{})
                                  new-id)]
    (when (not= resolved-data new-resolved-data)
      (save-resolved-data! task new-resolved-data))))

(defn complete-task!
  [task]
  (task-actions/*complete-task->
   {:db/id (:db/id task)}
   (fn []
     (routing/set-view! [:tasks-grid]))
   (fn [err]
     (logging/error "Failed to complete task" err))))

(defn reactivate-task!
  [state task]
  (task-actions/*reactivate-task->
   {:db/id (:db/id task)}
   (fn []
     ;;ensure complete-button is visible:
     (swap! state assoc :reviewed? true))
   (fn [err]
     (logging/error "Failed to reactivate task" err))))

(defn delete-task!
  [task]
  (entity-actions/*->disable! (:db/id task)
                              (fn [resp]
                                (routing/set-view! [:tasks-grid]))
                              error-utils/show-error!))

(defn start-delete-task!
  [task]
  (modals/open-modal!
   delete-confirmation-modal/modal-key
   {:body       (loc/tr :confirm-delete-task)
    :on-delete! (fn [_]
                  (delete-task! task))}))

(defn start-reassign-task!
  [task]
  (modals/open-modal!
   account-select/modal-key
   {:active-accounts (session/tenant-users)
    :header-text     (loc/tr :select-user)
    :on-select!      (fn [on-close! selected-account-id]
                       ;;optimistic update:
                       (swap! session/entities assoc-in
                         [(:db/id task) :task/assignee]
                         selected-account-id)
                       (entity-actions/*->field-update!
                        (:db/id task)
                        :task/assignee
                        selected-account-id
                        (fn [_]
                          (on-close!)
                          (routing/set-view! [:tasks-grid]))
                        (fn [err]
                          (let [entity (get @session/entities (:db/id task))
                                assignee (:task/assignee entity)]
                            ;;retract optimistic update:
                            (when (= assignee selected-account-id)
                              (swap! session/entities assoc-in
                                [(:db/id task) :task/assignee]
                                (:task/assignee task)))
                            (logging/log "Error assigning task : " err)))))}))
